/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Svchip_PaymentsInputs */

const en_svchip_payments = /** @type {(inputs: Svchip_PaymentsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Payments`)
};

const ar_svchip_payments = /** @type {(inputs: Svchip_PaymentsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`المدفوعات`)
};

const bn_svchip_payments = /** @type {(inputs: Svchip_PaymentsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`পেমেন্ট`)
};

const de_svchip_payments = /** @type {(inputs: Svchip_PaymentsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zahlungen`)
};

const es_svchip_payments = /** @type {(inputs: Svchip_PaymentsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pagos`)
};

const fr_svchip_payments = /** @type {(inputs: Svchip_PaymentsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Paiements`)
};

const pt_svchip_payments = /** @type {(inputs: Svchip_PaymentsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pagamentos`)
};

const zh_svchip_payments = /** @type {(inputs: Svchip_PaymentsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`付款`)
};

const tr_svchip_payments = /** @type {(inputs: Svchip_PaymentsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ödemeler`)
};

const ru_svchip_payments = /** @type {(inputs: Svchip_PaymentsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Платежи`)
};

const pl_svchip_payments = /** @type {(inputs: Svchip_PaymentsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Płatności`)
};

/**
* | output |
* | --- |
* | "Payments" |
*
* @param {Svchip_PaymentsInputs} inputs
* @param {{ locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }} options
* @returns {LocalizedString}
*/
export const svchip_payments = /** @type {((inputs?: Svchip_PaymentsInputs, options?: { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Svchip_PaymentsInputs, { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_svchip_payments(inputs)
	if (locale === "bn") return bn_svchip_payments(inputs)
	if (locale === "de") return de_svchip_payments(inputs)
	if (locale === "es") return es_svchip_payments(inputs)
	if (locale === "fr") return fr_svchip_payments(inputs)
	if (locale === "pt") return pt_svchip_payments(inputs)
	if (locale === "zh") return zh_svchip_payments(inputs)
	if (locale === "tr") return tr_svchip_payments(inputs)
	if (locale === "ru") return ru_svchip_payments(inputs)
	if (locale === "pl") return pl_svchip_payments(inputs)
	return en_svchip_payments(inputs)
});